import { CircularProgress, Divider, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import CourseCard from "examples/Cards/CourseCard";

import CrudService from "services/cruds-service";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import cover_letter_teaser_image from "assets/images/cover-letter-teaser.jpg";

import Carousel from "react-material-ui-carousel";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

const PrepareTab = ({
  job,
  recommendedCoursesLoader,
  recommendedCourses,
  exploreCard,
  feedback,
  setFeedback,
  getCourseOutline,
  courseOutlineLoader,
}) => {
  return (
    <>
      <MDTypography variant="h6" fontWeight="medium" mt={1}>
        Prepare Tab
      </MDTypography>
      <MDTypography variant="body2" mt={1}>
        Consider taking these courses to increase your chances of getting the
        job.
      </MDTypography>
      {recommendedCoursesLoader ? (
        <>
          <CircularProgress color="info" size={15} /> &nbsp; Loading
          recommendations...
        </>
      ) : (
        <MDBox item xs={6}>
          {recommendedCourses.length > 0 && (
            <>
              <MDTypography variant="h6" mt={1}>
                Recommended Courses
              </MDTypography>
              <MDBox mx={10}>
                <Carousel
                  sx={{
                    marginTop: "10px",
                    paddingTop: "40px",
                  }}
                  animation="slide"
                  navButtonsAlwaysVisible={true}
                  interval={2000}
                  duration={750}
                  changeOnFirstRender={true}
                >
                  {/* <Grid container spacing={4}> */}
                  {recommendedCourses.map((course) => {
                    return (
                      //   <Grid item xs={6} mt={3}>
                      <CourseCard
                        key={course._id}
                        style={{
                          padding: "10px",
                          height: "280px",
                          margin: "10px",
                        }}
                        image={course.app_image_location}
                        title={course.app_name.substring(0, 30) + "..."}
                        description={""}
                        label="Explore"
                        action={<></>}
                        exploreCard={() => exploreCard(course._id)}
                        moduleCount={course.course_names_videos.length}
                        height="auto"
                        purchased={course.purchased}
                        completed={course.completed}
                      />
                      //   </Grid>
                    );
                  })}
                  {/* </Grid> */}
                </Carousel>
              </MDBox>
            </>
          )}
        </MDBox>
      )}
      <MDBox
        key="course_outline_block"
        display="block"
        bgColor="white"
        color="text"
        borderRadius="xl"
        mt={2.5}
        py={1.875}
        px={1.875}
        lineHeight={1.5}
      >
        {courseOutlineLoader ? (
          <MDTypography variant="h6" fontWeight="medium" mt={1}>
            <CircularProgress color="info" size={15} /> &nbsp; Generating Course
            Outline
          </MDTypography>
        ) : (
          <>
            {job.course_outline && job.course_outline !== "" ? (
              <>
                <MDTypography variant="h6" fontWeight="medium" mt={1}>
                  Course Outline
                </MDTypography>
                <MDBox m={1} p={3}>
                  <div data-color-mode="light">
                    <MDEditor.Markdown
                      source={job.course_outline}
                      style={{ color: "#344767", background: "transparent" }}
                      components={{
                        p: ({ node, ...props }) => (
                          <p style={{ color: "#7b809a" }} {...props} />
                        ),
                      }}
                    />
                  </div>
                </MDBox>
                <Divider />
                <MDBox>
                  Not satisfied with the course outline? You can regenerate it
                  by giving feedback over here:
                  <br />
                  <MDInput
                    placeholder="Feedback"
                    value={feedback}
                    onChange={(e) => setFeedback(e.target.value)}
                    label="Feedback"
                    multiline
                    fullWidth
                    rows={5}
                  />
                  <br />
                  <MDButton
                    variant="contained"
                    color="info"
                    onClick={getCourseOutline}
                  >
                    Regenerate Course Outline
                  </MDButton>
                </MDBox>
              </>
            ) : (
              <>
                <MDButton
                  variant="gradient"
                  color="dark"
                  onClick={getCourseOutline}
                >
                  Generate custom course for this job
                </MDButton>
              </>
            )}
          </>
        )}
      </MDBox>
    </>
  );
};

export default PrepareTab;
